export default "__VITE_ASSET__8WkiKHYa__"